// Carries a projectId across navigation from a project-scoped screen (e.g.
// the Projects Dashboard, or a project's participations list) into the
// Patient Card's Documents tab, so its "Project" filter can default to it —
// and keeps defaulting to it on reload or in a separately-opened tab, until
// the user manually changes the filter themselves.
//
// localStorage (not redux, not sessionStorage):
// - redux resets on reload, so it can't survive a refresh.
// - sessionStorage is per-tab (with a copy inherited only by tabs spawned
//   FROM an existing one, e.g. ctrl-click/duplicate) — it wouldn't show the
//   same default in a tab opened independently (typed URL, bookmark), which
//   is exactly the "open in new tab" case this is meant to support.
//
// Keyed per recipientId (not one shared slot) so two tabs open on two
// different patients — each coming from a different project — can't race and
// overwrite each other's stored default; each patient's entry is independent.
//
// Not cleared after read (unlike a one-shot handoff) so it survives reload —
// clearDocumentsDefaultProjectId must be called explicitly once the user
// manually changes the filter (see FiltersToolbar.js), so their choice isn't
// silently overridden by the sticky default again next time they reload.

const STORAGE_KEY_PREFIX = 'zedoc:documentsDefaultProjectId:';

export const setDocumentsDefaultProjectId = (recipientId, projectId) => {
  if (!recipientId || !projectId) {
    return;
  }
  try {
    window.localStorage.setItem(
      `${STORAGE_KEY_PREFIX}${recipientId}`,
      projectId,
    );
  } catch (err) {
    // localStorage may be unavailable (e.g. private browsing) — the filter
    // simply won't default, which is a harmless degradation.
  }
};

export const getDocumentsDefaultProjectId = (recipientId) => {
  if (!recipientId) {
    return null;
  }
  try {
    return window.localStorage.getItem(`${STORAGE_KEY_PREFIX}${recipientId}`);
  } catch (err) {
    return null;
  }
};

export const clearDocumentsDefaultProjectId = (recipientId) => {
  if (!recipientId) {
    return;
  }
  try {
    window.localStorage.removeItem(`${STORAGE_KEY_PREFIX}${recipientId}`);
  } catch (err) {
    // ignore
  }
};
